module.exports = __webpack_public_path__ + "static/desktop/img/material-calendar-1.406d9a76.png";